import Core from '../../../lib/Core';
import Box from './Box';
import IconButton from './IconButton';
import Title from './Title';

export default function DrawerBar({
  title='[Title]',
  ...props
}) {
  return (
    <Box row className="sticky-top bg-main border-bottom">
      <IconButton
        className="mx-1"
        onClick={event => {
          event.stopPropagation();
          Core.closeDrawer()
        }}
      >
        <i className="material-icons">close</i>
      </IconButton>
      <Title className='c-purple'>
        {title}
      </Title>
    </Box>
  )
}
